var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGallery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/gallery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.0002 13.3333C30.0002 14.2174 29.649 15.0652 29.0239 15.6904C28.3987 16.3155 27.5509 16.6667 26.6668 16.6667C25.7828 16.6667 24.9349 16.3155 24.3098 15.6904C23.6847 15.0652 23.3335 14.2174 23.3335 13.3333C23.3335 12.4493 23.6847 11.6014 24.3098 10.9763C24.9349 10.3512 25.7828 10 26.6668 10C27.5509 10 28.3987 10.3512 29.0239 10.9763C29.649 11.6014 30.0002 12.4493 30.0002 13.3333Z",
    fill: "url(#paint0_linear_1927_15207)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9052 2.08301H20.0952C23.9435 2.08301 26.9585 2.08301 29.3118 2.39967C31.7185 2.72301 33.6185 3.39967 35.1102 4.88967C36.6018 6.38134 37.2768 8.28134 37.6002 10.6897C37.9168 13.0413 37.9168 16.0563 37.9168 19.9047V20.0513C37.9168 23.233 37.9168 25.8363 37.7435 27.9563C37.5702 30.0897 37.2152 31.868 36.4185 33.348C36.0685 33.9997 35.6352 34.5847 35.1102 35.1097C33.6185 36.6013 31.7185 37.2763 29.3102 37.5997C26.9585 37.9163 23.9435 37.9163 20.0952 37.9163H19.9052C16.0568 37.9163 13.0418 37.9163 10.6885 37.5997C8.28183 37.2763 6.38183 36.5997 4.89016 35.1097C3.5685 33.788 2.88516 32.143 2.5235 30.0997C2.16516 28.0947 2.10016 25.5997 2.08683 22.503C2.0835 21.7147 2.0835 20.8813 2.0835 20.0013V19.9047C2.0835 16.0563 2.0835 13.0413 2.40016 10.688C2.7235 8.28134 3.40016 6.38134 4.89016 4.88967C6.38183 3.39801 8.28183 2.72301 10.6902 2.39967C13.0418 2.08301 16.0568 2.08301 19.9052 2.08301ZM11.0218 4.87634C8.89183 5.16301 7.60683 5.70967 6.6585 6.65801C5.7085 7.60801 5.1635 8.89134 4.87683 11.023C4.58683 13.1897 4.5835 16.0363 4.5835 19.9997V21.4063L6.25183 19.9463C6.98362 19.3058 7.93153 18.9673 8.90355 18.9995C9.87557 19.0316 10.799 19.4321 11.4868 20.1197L18.6368 27.2697C19.1917 27.8244 19.9244 28.1656 20.7061 28.2333C21.4877 28.301 22.2682 28.0908 22.9102 27.6397L23.4068 27.2897C24.333 26.6389 25.4525 26.3216 26.5824 26.3897C27.7123 26.4579 28.7856 26.9073 29.6268 27.6647L34.3435 31.9097C34.8202 30.913 35.1018 29.603 35.2518 27.7547C35.4152 25.7463 35.4168 23.243 35.4168 19.9997C35.4168 16.0363 35.4135 13.1897 35.1235 11.023C34.8368 8.89134 34.2902 7.60634 33.3418 6.65634C32.3918 5.70801 31.1085 5.16301 28.9768 4.87634C26.8102 4.58634 23.9635 4.58301 20.0002 4.58301C16.0368 4.58301 13.1885 4.58634 11.0218 4.87634Z",
    fill: "url(#paint1_linear_1927_15207)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1927_15207",
    x1: 22.8439,
    y1: 10,
    x2: 30.0002,
    y2: 16.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1927_15207",
    x1: -0.548183,
    y1: 2.08301,
    x2: 37.9168,
    y2: 37.9163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA5E1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGallery);
export default __webpack_public_path__ + "static/media/icon_gallery.9488363971fa122de1ae177723173d2a.svg";
export { ForwardRef as ReactComponent };